import { isPlatformServer } from '@angular/common';
import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  PLATFORM_ID,
  provideAppInitializer,
} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

declare const process: { cwd: () => string };
declare const require: (module: string) => {
  existsSync: (path: string) => boolean;
  readFileSync: (path: string, encoding: string) => string;
  resolve: (...paths: string[]) => string;
};

export const provideIcons = (): EnvironmentProviders =>
  makeEnvironmentProviders([
    provideAppInitializer(() => {
      const platformId = inject(PLATFORM_ID);
      const domSanitizer = inject(DomSanitizer);
      const matIconRegistry = inject(MatIconRegistry);

      if (isPlatformServer(platformId)) {
        try {
          // On server side, read lucide.svg directly from disk for SSG prerendering
          const fs = require('fs');
          const path = require('path');
          const svgPath = path.resolve(
            process.cwd(),
            'libs/ng/core/config/src/lib/config/public/icons/lucide.svg',
          );

          if (fs.existsSync(svgPath)) {
            const svgContent = fs.readFileSync(svgPath, 'utf8');
            // NOSONAR: typescript:S6268 - SVG icon set is an internal trusted asset loaded from local filesystem for SSG
            matIconRegistry.addSvgIconSetLiteral(
              domSanitizer.bypassSecurityTrustHtml(svgContent), // NOSONAR
              {
                viewBox: '0 0 24 24',
              },
            );
            return;
          }
        } catch {
          // Fallback if filesystem is not accessible in server environment
        }
      }

      // Lucide icons for browser
      matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('icons/lucide.svg'), {
        viewBox: '0 0 24 24',
      });
    }),
  ]);
